import React from "react";
import { Table, Loader, Dimmer, Label } from "semantic-ui-react";
import DownloadButton from "@buttons/DownloadButton";
import { STATUS_MAP } from "@helpers/constant";
import { getFormattedDateOnly } from "@helpers/dates";
import { getStatusStyle } from "@helpers/prepareDetails";


const AssetDetailView = ({
  statusOption,
  assets = [],
  loading = false,
  operatorId,
  onStatusOptionChange,
  onDownloadClick,
  detailExportDisabled = false,
}) => {
  const option = statusOption;
  const statusOptions = Object.entries(STATUS_MAP).map(([value, status]) => ({
    value,
    text: status.label,
    color: status.color,
  }));
  const selectedValues = new Set(
    (option || "")
      .split(";")
      .map((x) => x.trim())
      .filter(Boolean),
  );

  return (
    <div className="height-100 gs-flex-container-vertical border-grey-1 p-0_5">
      <div className="flex-start mb-0_5">
        {statusOptions.map((status) => {
          const isSelected = selectedValues.has(status.value);
          const color = status.color || "grey";

          return (
            <Label
              key={status.value}
              style={{ border: "1px solid" }}
              inverted
              color={color}
              basic={!isSelected}
              className="clickable mr-0_5"
              onClick={() => {
                if (!onStatusOptionChange) return;

                const nextSelected = new Set(selectedValues);
                if (nextSelected.has(status.value)) {
                  nextSelected.delete(status.value);
                } else {
                  nextSelected.add(status.value);
                }

                const nextOption = statusOptions
                  .map((x) => x.value)
                  .filter((value) => nextSelected.has(value))
                  .join(";");

                onStatusOptionChange(nextOption);
              }}
            >
              {status.text}
            </Label>
          );
        })}
        <DownloadButton
          disabled={
            detailExportDisabled ||
            !operatorId ||
            loading ||
            !onDownloadClick
          }
          onClick={onDownloadClick}
          caption="Export"
          size="mini"
          loading={loading}
        />
      </div>
      <div className="border-grey-1 table-overflow flex-stretch-vertical">
        {loading && (
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        )}
        <Table celled selectable unstackable compact>
          <Table.Header style={{ position: "sticky" }}>
            <Table.Row>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Depot</Table.HeaderCell>
              <Table.HeaderCell>Location</Table.HeaderCell>
              <Table.HeaderCell>Pos</Table.HeaderCell>
              <Table.HeaderCell>MIN</Table.HeaderCell>
              <Table.HeaderCell>Game</Table.HeaderCell>
              <Table.HeaderCell>Manufacturer</Table.HeaderCell>
              <Table.HeaderCell>Date Installed</Table.HeaderCell>
              <Table.HeaderCell>GGR 12wk avg</Table.HeaderCell>
              <Table.HeaderCell>NBV</Table.HeaderCell>
              <Table.HeaderCell>Dep Wk</Table.HeaderCell>
              <Table.HeaderCell>GCF</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {assets.map((asset) => {
              const statusLabel = STATUS_MAP[asset.installStatus]?.label || "";
              return <Table.Row key={asset.assetId}>
                      <Table.Cell>
                        <div style={getStatusStyle(asset.installStatus)}>{statusLabel}</div>
                      </Table.Cell>
                      <Table.Cell>{asset.depotName || ""}</Table.Cell>
                      <Table.Cell>{asset.installSiteName + " " + asset.installSiteTown || ""}</Table.Cell>
                      <Table.Cell>{asset.pos || ""}</Table.Cell>
                      <Table.Cell>{asset.minNumber || ""}</Table.Cell>
                      <Table.Cell>{asset.gameName || ""}</Table.Cell>
                      <Table.Cell>{asset.manufacturerName || ""}</Table.Cell>
                      <Table.Cell textAlign="center">{getFormattedDateOnly(asset.installDate)}</Table.Cell>
                      <Table.Cell>{asset.ggR12Week || ""}</Table.Cell>
                      <Table.Cell>{asset.netBookValue || ""}</Table.Cell>
                      <Table.Cell>{asset.weeklyDepreciation || ""}</Table.Cell>
                      <Table.Cell>{asset.grossContentFee || ""}</Table.Cell>
                    </Table.Row>
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};

export default AssetDetailView;
